import { Bill_Processing_Filter_Api, Bill_Processing_Report_Api } from "../../../helpers/backend_helper";
import { BillProcessingFilter_Action_Success, BillProcessingReport_Action_Success, BillProcessingReport_ErrorAction } from "./action";
import { BILL_PROCESSING_FILTER_ACTION, BILL_PROCESSING_REPORT_ACTION } from "./actionType";

import { call, put, takeLatest } from "redux-saga/effects";

function* BillProcessingReport_GenFunc({ config }) {

    try {
        const response = yield call(Bill_Processing_Report_Api, config);
        response["Type"] = config.Type
        yield put(BillProcessingReport_Action_Success(response))
    } catch (error) { yield put(BillProcessingReport_ErrorAction()) }
}


function* BillProcessingFilter_GenFunc({ config }) {

    try {
        const response = yield call(Bill_Processing_Filter_Api, config);
        const updatedData = response.Data.map((data, index) => ({
            ...data,
            id: data.Customer
        }));

        yield put(BillProcessingFilter_Action_Success(updatedData))
    } catch (error) { yield put(BillProcessingReport_ErrorAction()) }
}

function* BillProcessingSaga() {
    yield takeLatest(BILL_PROCESSING_REPORT_ACTION, BillProcessingReport_GenFunc)
    yield takeLatest(BILL_PROCESSING_FILTER_ACTION, BillProcessingFilter_GenFunc)

}

export default BillProcessingSaga;